// noinspection ES6ConvertVarToLetConst
/* global $, _ */
/* jshint eqnull:true */

var CoreConfigDisplayCtrl = function ($scope, $timeout) {
    'use strict';

    $scope.showCcdCheckboxes = false; // show checkboxes?
    $scope.ccdCheckboxes = {}; // checkboxes (keyed by id)
    $scope.ccdSelectAllCheckboxes = {}; // select all checkboxes (keyed by tabId)
    $scope.ccdCounts = {}; // how may checkboxes are checked (keyed by tabId)
    $scope.ccdTabTitles = {}; // tab titles (keyed by tabId)
    $scope.ccdCountsTotal = 0; // sum of all ccdCounts
    $scope.showModal = false;
    $scope.showSuccessMessage = false;
    $scope.visibility = {
        basic: '0', advanced: '0', admin: '0'
    };

    // when a CHECKBOX is checked or unchecked within a given tab:
    // if all checkboxes for the tab are checked, the SELECT ALL CHECKBOX must be checked
    // else the SELECT ALL CHECKBOX must be unchecked
    var adjustSelectAllCheckbox = function (tabId) {
        var checkboxes = _.filter($scope.ccdCheckboxes, function (checkbox) {
            return checkbox.tabId === tabId;
        });
        var values = checkboxes.map(function (checkbox) {
            return checkbox.checked;
        });
        $scope.ccdSelectAllCheckboxes[tabId] = _.every(values);
    };

    // when the SELECT ALL CHECKBOX is checked or unchecked within a given tab:
    // if it is checked, all CHECKBOXES for the tab must be checked
    // else all CHECKBOXES for the tab must be unchecked
    var selectAllCheckboxes = function (tabId, toggleOn) {
        $scope.ccdCheckboxes = _.reduce($scope.ccdCheckboxes, function (acc, checkbox, id) {
            checkbox.checked = checkbox.tabId === tabId ? toggleOn : checkbox.checked;
            acc[id] = checkbox;
            return acc;
        }, {});
    };

    // updates counts as to how may checkboxes are checked
    var updateCounts = function () {
        $scope.ccdCounts = _.reduce($scope.ccdCheckboxes, function (acc, checkbox) {
            if (checkbox.checked) {
                acc[checkbox.tabId] = acc[checkbox.tabId] == null ? 1 : acc[checkbox.tabId] + 1;
            }
            return acc;
        }, {});
        var counts = _.map($scope.ccdCounts);
        $scope.ccdCountsTotal = counts.reduce(function (acc, n) {
            return acc + n;
        }, 0);
    };

    // unchecks all checkboxes and select all checkboxes and resets all counts
    var clearAll = function () {
        var tabIds = _.map($scope.ccdCheckboxes, function (checkbox) {
            return checkbox.tabId;
        });
        _.unique(tabIds).forEach(function (tabId) {
            $scope.clear(tabId);
        });
    };

    var openModal = function (/* evt */) {
        $scope.showModal = true;
        $scope.visibility = {
            basic: '0', advanced: '0', admin: '0'
        };
    };
    // see coreConfigDisplay.js
    document.addEventListener('onClickGlobalActionBtnBulkUpdateFieldVisibility', openModal);

    // sets tab titles
    $scope.initCcdTabTitles = function (strCcdTabTitles) {
        strCcdTabTitles = strCcdTabTitles.replace('[', '').replace(']', '');
        var tabTitles = strCcdTabTitles.split(',');
        $scope.ccdTabTitles = tabTitles.reduce(function (acc, v) {
            var parts = v.split('-');
            var tabId = parts.length > 0 && parts[0] ? parts[0].trim() : null;
            var tabTitle = parts.length > 1 && parts[1] ? parts[1].trim() : null;
            if (tabId && tabTitle && /^\d+$/.test(tabId) && tabTitle.length) {
                acc[tabId] = tabTitle;
            }
            return acc;
        }, {});
    };

    $scope.toggleCheckbox = function (id) {
        var checkbox = $scope.ccdCheckboxes[id];
        adjustSelectAllCheckbox(checkbox.tabId);
        updateCounts();
    };

    $scope.toggleSelectAllCheckbox = function (tabId) {
        var toggleOn = this.ccdSelectAllCheckboxes[tabId];
        selectAllCheckboxes(tabId, toggleOn);
        updateCounts();
    };

    // button handler
    $scope.clear = function (tabId) {
        selectAllCheckboxes(tabId, false);
        adjustSelectAllCheckbox(tabId);
        updateCounts();
    };

    $scope.closeModal = function () {
        $scope.showModal = false;
    };

    // button handler
    $scope.save = function () {
        _.forEach($scope.ccdCheckboxes, function (cb) {
            if (cb.checked) {
                var selector = 'input[type=checkbox][data-ccd-checkbox-id=' + cb.id + '][data-ccd-checkbox-tab-id=' + cb.tabId + ']';
                var checkbox = $($(selector)[0]);
                var selects = checkbox.closest('li').find('select');
                $(selects[0]).val($scope.visibility.basic).change();
                $(selects[1]).val($scope.visibility.advanced).change();
                $(selects[2]).val($scope.visibility.admin).change();
            }
        });
        clearAll();
        $scope.showModal = false;
        $scope.showSuccessMessage = true;

        $timeout(function () {
            $scope.showSuccessMessage = false;
        }, 7000);
    };

    $scope.closeSuccessMessage = function () {
        $scope.showSuccessMessage = false;
    };

    return $scope;
};

CoreConfigDisplayCtrl.$inject = ['$scope', '$timeout'];
angular.module('app').controller('CoreConfigDisplayCtrl', CoreConfigDisplayCtrl);
